<script setup lang="ts">
const { t } = useI18n();
definePageMeta({
  layout: 'auth',
  middleware: 'guest',
});
useSeoMeta({
  title: t('pages.auth.password.recovery.title'),
  description: t('pages.auth.password.recovery.description'),
});
</script>

<template>
  <auth-password-recovery-form>
    <template #header>
      <nav-auth-panel>{{ t('pages.auth.password.recovery.title') }}</nav-auth-panel>
    </template>
  </auth-password-recovery-form>
</template>
